import { render } from "./ProducerRateForm.vue?vue&type=template&id=75ae5e7e"
import script from "./ProducerRateForm.vue?vue&type=script&lang=js"
export * from "./ProducerRateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__